export const STATE_SLICE_MAP: Record<string, (state: any) => any> = {
  university_details: (state) => state.university,
  default: (state) => state.page,
};

export const INITIAL_FORM_STATE = {
  componentFields: {},
  metadataStates: {},
  metadataErrors: {},
  metadataMessages: {},
  componentFieldErrors: {},
  componentFieldMessages: {},
};

